import {SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS} from "./constants";
import { globalCatch } from "../../../_services/global-catch";
import {convocationResignations} from "../../../_services/convocation-resignations-service";
import {documentApi} from "../../../_services/fct-service";
import async from "async";
import {downloadFile} from "../../../utils";
import {TOKEN_EXPEDIENT} from "../../../constants";

export const setConvocationResignationsAcademicPrograms = (payload) => ({
    type: SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS,
    payload,
});

export const getConvocationResignationsAcademicPrograms = (locale) =>
    globalCatch.catch(async (dispatch) => {
        const convocationResignationsAcademicPrograms = await (
            await convocationResignations()
        ).convocationResignationsAcademicProgramsGet(locale);
        dispatch(setConvocationResignationsAcademicPrograms(convocationResignationsAcademicPrograms));
    });

export const sendConvocationResignations = globalCatch.catch(
  async (academic_program_id, formData) => {
    const url = `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/convocation-resignations/academic-programs/${academic_program_id}`;

    const response = await fetch(url, {
      method: 'POST',
      body: formData,
      credentials: 'include'
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error enviando solicitud: ${response.status} ${errorText}`);
    }

    return response.json();
  }
);


export const downloadAnnex = globalCatch.catch(
    async (fileName = 'anexo_renuncia_convocatoria.pdf') => {
        return downloadFile({
            url: `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/convocation-resignations/annex`,
            fileName,
            TOKEN: TOKEN_EXPEDIENT,
        });
    }
);

